import React from 'react';
import { connect } from 'react-redux';
import mapStateToProps from '../redux/mapStateToProps';

// React App or Base component
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prevLocation: null,
    };
    __DEBUG__ && console.log('App.constructor props:', props);
  }

  // https://stackoverflow.com/questions/39288915/detect-previous-path-in-react-router
  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      // console.log('prev', this.props.location);
      this.setState({ prevLocation: this.props.location });
    }
  }

  componentDidMount() {
    // __DEBUG__ && console.log('location', this.props.location);
  }

  render() {
    let { hostInfoListStatus, hostInfoList, auth } = this.props;
    let isLoading = hostInfoListStatus.isLoading;

    // if (isLoading) {
    //   return (
    //     <div className="center">
    //       <ReactSpinner />
    //     </div>
    //   )
    // }

    if (hostInfoListStatus.errorMessage) {
      return (
        <div className='center'>
          <h1>Error loading!</h1>
          <h2>Please try again later or contact site maintainer.</h2>
          <div style={{ textAlign: 'center' }}>
            <a href='/'>Home</a>
          </div>
        </div>
      );
    }

    const childrenWithProps = React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, { ...this.props, ...this.state })
    );

    return (
      <div className='app'>
        {(isLoading || (auth.isAuthenticated && hostInfoList.length === 0)) && (
          <div className='app-loading-holder'>
            <div className='app-loading'>
              <i className='fa fa-spinner fa-spin fa-5x fa-fw' />
            </div>
          </div>
        )}
        {childrenWithProps}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  // pass down dispatch  to props, so we can use those in child components. e.g. props.dispatch
  return {
    dispatch: dispatch,
    // don't pass down as actions and use `import * as actions from '/path/to/actions'` which provide IDE code navigation
    //actions: actions,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js